/*
*   组织架构动图组件
*   zxw
*   2024-01-18
*/

import { useEffect, useState } from 'react';
import { OrganizationChart, CollapseExpandIcon } from '@ant-design/graphs';
import { Flex, Image } from 'antd';
const { PlusMinusIcon } = CollapseExpandIcon;
import CNF from '../../incs/Config';
import { winWidth } from '../../incs/FunHelper';
const OrgStructureGraph = (props) => {
    const [data, setData] = useState([]);

    const { children, streamStatus } = props;

    // 加载中显示默认图片
    if (streamStatus === 'loading') {
        return <Skeleton.Image active={true} />;
    }

    useEffect(() => {
        const childrenJson = JSON.parse(children);
        if (childrenJson) {
            let nodes = [];
            let edges = [];
            for (let i = 0; i < childrenJson.length; i++) {
                let item = childrenJson[i];
                nodes.push({
                    id: item.sid,
                    data: item,
                });
                if (item.up_sid) {
                    edges.push({
                        source: item.up_sid,
                        target: item.sid,
                    })
                }
            }
            setData({
                'nodes': nodes,
                'edges': edges,
            });
        }
    }, [props]);

    const options = {
        autoFit: 'view',
        data,
        width: winWidth / 3,
        padding: [0, 0, 20, 0],
        node: {
            style: {
                component: (d) => {
                    const { title, name, level, icon } = d.data || {};
                    var backgroundColor = CNF.swatches[0];
                    if (level > 0) backgroundColor = CNF.swatches.default[level - 1];
                    // const isActive = d.states?.includes('active');
                    return <div style={{
                        backgroundColor: backgroundColor,
                        borderRadius: 4,
                        width: 130,
                        height: 44,
                        color: '#fff',
                        textAlign: 'center',
                    }}><Flex>
                            {
                                icon ? <Image src={CNF.ossApi + icon} preview={false} width={34} height={34} style={{ marginTop: 5, marginLeft: 5 }} /> : ''
                            }
                            <div style={{
                                width: icon ? 130 - 34 : 130,
                                height: 44,
                                display: 'flex',
                                justifyContent: 'center', /* 水平居中 */
                                alignItems: 'center',     /* 垂直居中 */
                            }}>
                                {title}
                                {
                                    name ? <><br />{name}</> : ''
                                }
                            </div>
                        </Flex>
                    </div>
                },
                size: [130, 44],
            },
        },
        edge: {
            // 默认连接线样式
            style: {
                stroke: '#1890ff',
                lineWidth: 1,
                endArrow: { // 结束箭头
                    type: 'triangle',
                    fill: '#1890ff',
                    stroke: '#1890ff',
                    lineWidth: 1,
                },
            },
        },
        behaviors: (prev) => [...prev, 'hover-activate-chain'],
    };

    const updateCollapseExpandBehavior = (options) => {
        return (transforms) => [
            ...transforms.filter((transform) => (transform).key !== 'collapse-expand-react-node'),
            {
                ...(transforms.find((transform) => (transform).key === 'collapse-expand-react-node') || ({})),
                ...options,
            },
        ];
    };

    return <OrganizationChart {...options} transforms={updateCollapseExpandBehavior({
        enable: true,
        iconRender: (isCollapsed) => <PlusMinusIcon isCollapsed={isCollapsed} />,
        iconOffsetX: 0,
    })} />
}
export default OrgStructureGraph;